


<template>
  <div id="tst">
    <v-tooltip style="z-index: 929;" bottom>
      <v-btn slot="activator" dark icon small flat @click.native="rmvCertificado()">
        <v-icon class="material-icons">delete_outline</v-icon>
      </v-btn>
      <span>Remover certificado</span>
    </v-tooltip>
  </div>
</template>
<script>
import CertificadoService from "@/domain/conta/empresa/certificado/CertificadoService.js";
export default {
  props: ["conta", "empresa", "alert", "nota", "table"],
  components: {},

  data: () => ({}),
  mounted: function() {
    this.$nextTick(function() {});
  },
  updated: function() {},
  watch: {},
  computed: {},
  methods: {
    rmvCertificado: function() {
      this.service = new CertificadoService(this.$http);
      this.service.removerDaConta(this.nota.item._id).then(res => {
        if (res) {
          res.body.message != undefined && res.body.message.length != 0
            ? (this.alert.snack.text = res.body.message)
            : (this.alert.snack.text = res.infoMessage.msg);
          if (res.ok) {
            this.alert.snackSuccess();
            this.$emit("attTableEmp", res);
          } else {
            this.alert.snackDanger();
          }
          this.alert.snack.show = true;
        }
      });
    }
  }
};
</script>
<style>
#tst {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/rmvCertificado/RmvCertificado.vue